import MetaRouteList from './modules/metaRoute';
import workSpaceRouteList from './modules/workSpaceRoute';
import DataQualityRouteList from './modules/dataQualityRoute';
import DataStandardRouteList from './modules/dataStandardRoute';
import MasterDataRouteList from './modules/masterDataRoute';
import OperationsRouteList from './modules/opeartionRoute';
import DataResourceRouteList from './modules/dataResourceRoute';
import UseCaseRouteList from './modules/useCaseRoute';
import aiGovernanceRouteList from './modules/aiGovernanceRoute';

const routeList = [
  ...MetaRouteList,
  ...workSpaceRouteList,
  ...DataQualityRouteList,
  ...DataStandardRouteList,
  ...OperationsRouteList,
  ...MasterDataRouteList,
  ...DataResourceRouteList,
  ...UseCaseRouteList,
  ...aiGovernanceRouteList,
];

export default routeList;
